import React from 'react';
import { Grid } from '@material-ui/core';

import { FormTextField, FormSelect } from '../../../components';
import {
  KEY_STORE_DEPLOYMENT_FILTER_TYPE,
  KEY_STORE_STATUS,
  KEY_STORE_TYPE_FILTER_TYPE,
} from '../../../constants';

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="key-store-filter-by-name"
      data-apim-test="key-store-filter-by-name"
    />
  </Grid>
);


export const FilterByDeploymentType = (props) => (
  <Grid item md={3} sm={2} xs={12}>
    <FormSelect
      {...props}
      id="key-store-filter-by-deployment-type"
      data-apim-test="key-store-filter-by-deployment-type"
      data={KEY_STORE_DEPLOYMENT_FILTER_TYPE}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterByKeyStoreType = (props) => (
  <Grid item md={3} sm={2} xs={12}>
    <FormSelect
      {...props}
      id="key-store-filter-by-key-store-type"
      data-apim-test="key-store-filter-by-key-store-type"
      data={KEY_STORE_TYPE_FILTER_TYPE}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterByStatus = (props) => (
  <Grid item md={2} sm={2} xs={12}>
    <FormSelect
      {...props}
      id="key-store-filter-by-status"
      data-apim-test="key-store-filter-by-status"
      data={KEY_STORE_STATUS}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterAndSortSeparator = () => (
  <Grid item md={4} />
);

